import { z } from 'zod';
import { listSearchParam } from '@/common/utils/listSearchParam';
import { categoryLensKeys } from './categoryLens';

export { selectedValues, toListParam } from '@/common/utils/listSearchParam';

// The selected lenses and Loop scope live in the URL so they survive a refresh and can be shared or
// linked to. A single selection is the bare value, several are an array — see `listSearchParam`.
//
// `.catch(undefined)` rather than a hard failure: a hand-edited, bookmarked or stale link with an
// unknown lens or a malformed loop id must land on the unfiltered feed, never on the error boundary.
// A filter is not worth breaking a page over.
export const loopIntelligenceSearchSchema = z.object({
  lens: listSearchParam(z.enum(categoryLensKeys)),
  loop: listSearchParam(z.coerce.number().int().positive()),
});

export type LoopIntelligenceSearch = z.output<typeof loopIntelligenceSearchSchema>;
